import { HttpMarkChangeManageList } from '@/service/misc';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tabs: { show: true },
            formData: {
                isManage: true,
                search: {
                    'IN_status': [10, 15],
                }
            },
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    methods: {
        ajaxRequest: HttpMarkChangeManageList,
        handleOperates(data) {
            this.$emit('on-data', data)
        },
    },
    computed: {
        ...mapGetters( 'dictionary', [ 'getCusproductList', 'getUserManageWarehouseList']),
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.markchange.exchange_plan_no', { defaultValue: "换标上架计划单号" }),
                    key: 'EQ_changeLabelPlanNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_orgWarehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getUserManageWarehouseList.map(item=>{
                        return {
                            value: item.attach.id,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    show: true,
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    title: "No.",
                    type: 'index',
                    width: 60,
                },
                {
                    title: this.$t('fbb.markchange.exchange_plan_no', { defaultValue: '换标上架计划单号' }),
                    key: 'changeLabelPlanNo',
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'orgWarehouseCode',
                    render: (h, { row }) => this.findRenderLabel(this.getUserManageWarehouseList, row.orgWarehouseCode) || '--'
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    key: 'lineId',
                    render: ( h, { row })=>{
                        return this.findRenderLabel(this.getCusproductList, row.lineId) || '--'
                    }
                },
                {
                    title: this.$t('fbb.alloment.order_status', { defaultValue: '单据状态' }),
                    key: 'inboundPlanOrderStatus',
                    render: (h, { row }) => {
                        const status = row.status;
                        const { theme = 'default', label } = this.getBillStatus1.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{status ? label : this.$t('fbb.headlogistics.draft', { defaultValue: '草稿' })}</vButton>
                    }
                },
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 90,
                    align: 'center',
                    render: (h, { row }) => {
                        return <vButton theme='primary' onClick={this.handleOperates.bind(this, row)}>{this.$t('fbb.inbound.choose', { defaultValue: '选择' })}</vButton>
                    }
                }
            ];
        },
    },
};




